<template>
  <div v-if="customer.id">
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <div class="row">
      <div class="col-lg-12 ls-lg-margin-bottom-in-sm">
        <div class="col-lg-12">
          <router-link slot="button" :to="{ name: 'edit_customer', params: { id: customer.id }}" class="ls-btn ls-btn-primary ls-xs-margin-bottom ls-float-right ls-no-margin ls-xs-margin-right">
            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            <span>{{ $t('customers.main.edit') }}</span>
          </router-link>
          <authorized-link tag="destroy_customer">
            <a href="javascript:void(0)" @click="setInactiveData(customer, index)" class="ls-btn ls-btn-danger ls-float-right ls-xs-margin-bottom ls-xs-margin-right ls-no-margin">{{ $t('application.button.inactive') }}</a>
          </authorized-link>
        </div>
      </div>
    </div>
    <div class="col-lg-12 ls-no-padding ls-display-flex flex-wrap-wrap">
      <div v-if="customer" class="col-md-12 col-lg-7 col-xlg-6 ls-display-flex ls-md-margin-bottom">
        <div class="ls-box ls-sm-space ls-display-flex flex-wrap-wrap">
          <header>
            <h3 class="ls-title-3">{{ $t('customers.show.subscriber_data') }}</h3>
          </header>
          <br>
          <div class="ls-box-body row ls-display-flex flex-wrap-wrap">
            <label class="ls-label col-lg-4 col-xlg-3 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.id') }}</b>
              <p data-test="customer.name">{{ customer.id }}</p>
            </label>
            <label class="ls-label col-lg-4 col-xlg-3 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.show.name') }}</b>
              <p data-test="customer.name">{{ customer.name }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.show.cpf') }}</b>
              <p data-test="customer.cpf">{{ getCpf }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6" v-if="customer.kind === 'C'">
              <b class="ls-label-text">{{ $t('customers.show.cnpj') }}</b>
              <p data-test="customer.cnpj">{{ getCnpj }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.show.subscriber_type') }}</b>
              <p data-test="customer.person_type" v-if="customer.kind === 'P' ">{{ $t('customers.show.personal') }}</p>
              <p data-test="customer.person_type" v-else>{{ $t('customers.show.customer_person') }}</p>
            </label>
            <label class="ls-label col-lg-4 col-xlg-3 col-xs-6" v-if="customer.contact">
              <b class="ls-label-text">{{ $t('customers.show.since') }}</b>
              <p data-test="customer.phone">{{ date.parseDate(customer.created_at) }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6" v-if="customer.kind === 'C'">
              <b class="ls-label-text">{{ $t('customers.show.company_name') }}</b>
              <p data-test="customer.company_name">{{ customer.company_name }}</p>
            </label>
            <label class="ls-label col-lg-4 col-xlg-3 col-xs-6" v-if="customer.contact">
              <b class="ls-label-text">{{ $t('customers.show.phone') }}</b>
              <p data-test="customer.phone">{{ getPhone }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-md-12" v-if="customer.kind === 'C'">
              <b class="ls-label-text">{{ $t('customers.show.trade_name') }}</b>
              <p data-test="customer.trade_name">{{ customer.trade_name }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-md-12">
              <b class="ls-label-text">{{ $t('customers.show.mail') }}</b>
              <p data-test="customer.email">{{ customer.email }}</p>
            </label>
            <label v-if="getCode" class="ls-label col-xlg-3 col-lg-4 col-md-12">
              <b class="ls-label-text">{{ $t('customers.show.customer_code') }}</b>
              <p data-test="customer.customer_code">{{ getCode }}</p>
            </label>
          </div>
          <header v-if="customer.address">
            <h3 class="ls-title-3">{{ $t('customers.show.address') }}</h3>
          </header>
          <div class="ls-box-body row ls-display-flex flex-wrap-wrap">
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-12">
              <b class="ls-label-text">{{ $t('customers.attributes.address.street') }}</b>
              <p>{{ customer.address.street }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.address.number') }}</b>
              <p>{{ customer.address.number }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4  col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.address.neighborhood') }}</b>
              <p>{{ customer.address.neighborhood }}</p>
            </label>
            <label v-if="customer.address.complement" class="ls-label col-xlg-3 col-lg-2 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.address.complement') }}</b>
              <p>{{ customer.address.complement }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.address.postal_code') }}</b>
              <p>{{ customer.address.postal_code }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.address.city') }}</b>
              <p>{{ customer.address.city }}</p>
            </label>
            <label class="ls-label col-xlg-3 col-lg-4 col-xs-6">
              <b class="ls-label-text">{{ $t('customers.attributes.address.state') }}</b>
              <p>{{ customer.address.state }}</p>
            </label>
          </div>
          <br>
        </div>
      </div>
      <div class="col-xlg-6 col-lg-5 ls-no-padding ls-display-flex flex-wrap-wrap">
        <div class="col-md-12 col-lg-12 col-xlg-12 ls-md-margin-bottom">
          <div class="ls-box ls-sm-space align-itens-strech">
            <header>
              <h3 class="ls-title-3">{{ $t('customers.show.last_invoices') }}</h3>
            </header>
            <table v-if="invoices.length" class="ls-table ls-txt-center ls-sm-space ls-table-striped">
              <thead>
                <tr>
                  <th class="th-subs">{{ $t('customers.show.subscription') }}</th>
                  <th class="th-value">{{ $t('customers.show.value') }}</th>
                  <th class="th-status">{{ $t('customers.show.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="invoice in invoices">
                  <td v-if="invoice.contract" class="th-subs"><router-link class="link" :to="{ name: 'contract_details', params: { id: invoice.contract.id }}" title="">{{ invoice.contract.id }}</router-link></td>
                  <td class="th-value">R$ {{ money.parseViewValue(invoice.amount_due) }}</td>
                  <td class="th-status">{{ $t('invoices.attributes.statuses.' + invoice.status) }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else>{{ $t('invoices.alerts.not_available') }}</p>
          </div>
        </div>
        <div class="col-lg-12 ls-md-margin-bottom">
          <div class="ls-box ls-sm-space align-itens-strech">
            <header class="d-flex">
              <div class="col-md-8 col-lg-7 align-self-center">
                <h3 class="ls-title-3">{{ $t('customers.show.subscriptions_history') }}</h3>
              </div>
              <div class="col-xlg-5 col-lg-6">
                <router-link v-if="customer.active" slot="button" :to="{ name: 'contracts_new', params: { customer: customer }}" class="ls-btn ls-no-margin ls-float-right">
                  <i class="fa fa-calendar-plus-o" aria-hidden="true"></i>
                  <span>{{ $t('customers.main.create_contract') }}</span>
                </router-link>
              </div>
            </header>
            <table v-if="contracts.length" class="ls-table ls-txt-center ls-sm-space ls-table-striped">
              <thead>
                <tr>
                  <th class="th-id">{{ $t('customers.show.subscription') }}</th>
                  <th class="th-date hidden-xs">{{ $t('customers.show.subscription_init') }}</th>
                  <th class="hidden-sm hidden-md hidden-xs hidden-lg">{{ $t('customers.show.subscription_end') }}</th>
                  <th class="th-status">{{ $t('customers.show.status') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contract in contracts">
                  <td class="th-id"><router-link class="link" :to="{ name: 'contract_details', params: { id: contract.id }}" title="">{{ contract.id }}</router-link></td>
                  <td class="th-date hidden-xs">{{ beginDate(contract) }}</td>
                  <td class="th-date hidden-sm hidden-md hidden-xs  hidden-lg">{{ endDate(contract) }}</td>
                  <td class="th-status">{{ $t('contracts.attributes.statuses.' + contract.status) }}</td>
                </tr>
              </tbody>
            </table>
            <p class="ls-md-margin-top" v-else>{{ $t('contracts.alerts.subscription_not_found') }}</p>
          </div>
        </div>
      </div>
    </div>
    <modal-inactive v-model="inactiveObjects"></modal-inactive>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import BoxItem from './components/BoxItem.vue'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ModalInactive from './components/ModalInactive'
  import * as format from 'src/utils/form'
  import money from 'src/utils/money'
  import date from 'src/utils/date'
  import filter from 'src/utils/filter'
  import scroll from 'src/utils/scroll'

  export default {
    name: 'ShowCustomer',
    components: {
      BoxItem,
      Breadcrumb,
      ModalInactive
    },
    data () {
      return {
        money: money,
        inactiveObjects: { show: false },
        date: date,
        crumbs: {
          'ico': 'ls-ico-users',
          'section': this.$t('customers.show.view_subscriber'),
          'paths': {
            0: {
              'title': this.$t('customers.main.subscribers'),
              'path': '/customers'
            },
            1: {
              'title': this.$t('customers.main.details'),
              'path': ''
            }
          }
        },
        error: false
      }
    },
    mounted () {
      this.loadCustomer(this.$route.params.id).then(this.getInvoicesByCustomer).then(this.getContracts).then(this.afterLoad)
    },
    computed: {
      ...mapGetters(['customer', 'contracts', 'invoices']),
      getStatus: function () {
        return this.customer.active === false ? 'Inativo' : 'Ativo'
      },
      getCpf: function () {
        return this.customer.cpf !== null ? format.cpf(this.customer.cpf) : '-'
      },
      getCnpj: function () {
        return this.customer.cnpj !== null ? format.cnpj(this.customer.cnpj) : '-'
      },
      getCode: function () {
        return this.customer.code
      },
      getPhone: function () {
        return format.ddd(this.customer.contact.area_code) + ' ' + format.phone(this.customer.contact.number)
      }
    },
    methods: {
      ...mapActions(['loadCustomer', 'loadContracts', 'loadInvoicesByCustomer']),
      ...mapMutations(['setPageData', 'setPagination']),
      setInactiveData () {
        this.inactiveObjects.show = true
        this.inactiveObjects.callback = scroll.scrollToFlash
      },
      getInvoicesByCustomer () {
        this.$loader.show()
        var params = { subscriber_id: this.customer.id, pagination: { per_page: 5, current_page: 1 } }
        return this.loadInvoicesByCustomer(params)
      },
      afterLoad () {
        this.$loader.hide()
      },
      getContracts () {
        this.$loader.show()
        var params = filter.toQueryWithPagination({ 'contract[customer_id]': this.customer.id }, { per_page: 999, current_page: 1 })
        return this.loadContracts(params)
      },
      getActiveContracts () {
        var actives = 0
        for (var contract of this.contracts) {
          if (contract.active === 'active') actives += 1
        }
        return actives
      },
      beginDate (contract) {
        return this.findDateByStatus(contract, 2, this.$t('contracts.attributes.statuses.pending'))
      },
      endDate (contract) {
        return this.findDateByStatus(contract, 3, '-')
      },
      findDateByStatus (contract, status, notFoundMessage) {
        for (var history of contract.history_contract_statuses) {
          if (history.status === status) return date.parseDate(history.created_at)
        }
        return notFoundMessage
      }
    },
    beforeDestroy () {
      this.setPageData({})
      this.setPagination({})
    }
  }
</script>
<style lang="scss" scoped>
  .customer-data {
    margin-bottom: 30px!important;
  }
  .text-wrap {
    font-size: 80%;
  }

  .d-flex {
    display: flex;
  }

  .ls-board-box .ls-box-filter [class*="ls-title-"], .ls-label b, .ls-label label, .ls-label .ls-label-text, .ls-table.ls-sm-space th td, .ls-table.ls-sm-space th, .ls-label b+p, .ls-label .ls-label-text+p, .font_default, .ls-table td {
    font-size: 13px !important;
  }

  .ls-board-box .ls-box strong div, .ls-board-box .ls-box strong div span {
    line-height: 2;
  }
  .align-self-center {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// Show.vue?72e92f76